import * as React from 'react'
import styled from 'styled-components'
import Stepper, {StepperProps} from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import StepConnector from '@mui/material/StepConnector'
import progressbarStyles, {progressBarStepperStyles} from './progressbar.styles'
import TypographyAtom from '../../to_content/typography/typography.atom'
import utils from '../../../utils'

interface ApStepperProps extends StepperProps {
  ap_progress_status_arr: string[]
  ap_progress_step: number
  // eslint-disable-next-line
  ap_is_step_failed?: boolean
}

const QontoConnector = styled(StepConnector)`
  ${progressBarStepperStyles};
`

const QontoStepIcon = function () {
  return null
}

const apAtomName = {ap_atom_name: 'progressBarAtom'}

const ProgressBarStylesWrapper = styled.div`
  ${progressbarStyles};
`

const ProgressBarAtom = function (props: ApStepperProps) {
  const {
    ap_progress_status_arr,
    ap_progress_step,
    ap_is_step_failed = false,
  } = props

  const isFailed = (index: number) =>
    index + 1 === ap_progress_step && ap_is_step_failed

  return (
    <ProgressBarStylesWrapper>
      <Stepper
        {...apAtomName}
        alternativeLabel
        activeStep={ap_progress_step}
        connector={null}
      >
        {ap_progress_status_arr.map((label, index: number) => (
          <Step key={label}>
            <QontoConnector
              className={utils.classnames({
                'MuiStepConnector-step-failed': isFailed(index),
              })}
            />
            <StepLabel StepIconComponent={QontoStepIcon}>
              {index < ap_progress_step ? (
                <TypographyAtom
                  ap_color={isFailed(index) ? 'error' : ''}
                  ahd_type="currentStep"
                >
                  {label}
                </TypographyAtom>
              ) : (
                <TypographyAtom
                  ap_color={isFailed(index) ? 'error' : ''}
                  ahd_type="step"
                >
                  {label}
                </TypographyAtom>
              )}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </ProgressBarStylesWrapper>
  )
}

export default ProgressBarAtom
